import { render, staticRenderFns } from "./ReadKit.vue?vue&type=template&id=45f54f52&scoped=true&"
import script from "./ReadKit.vue?vue&type=script&lang=js&"
export * from "./ReadKit.vue?vue&type=script&lang=js&"
import style0 from "./ReadKit.vue?vue&type=style&index=0&id=45f54f52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f54f52",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VCol,VForm})
